import { Route, Routes } from "react-router-dom"

import OperationsHistory from "../../pages/OperationsHistory"

import { ROUTES_PATHS } from "../../utils/constants"
import OperationHistoryDetails from "../../pages/OperationHistoryDetails"

const OperationsHistoryFlow = () => (
  <Routes>
    <Route element={<OperationsHistory />} index />
    <Route
      element={<OperationHistoryDetails />}
      path={`/:${ROUTES_PATHS.operationId}`}
    />
  </Routes>
)

export default OperationsHistoryFlow
